import React, { ReactNode } from "react";

interface IProductConfig {
  color?: string;
  size?: string;
  labels: {
    colourText?: ReactNode;
    sizeText?: ReactNode;
  };
  showSize?: boolean;
}

const ProductConfig = ({
  color,
  size,
  labels,
  showSize = true,
}: IProductConfig) => {
  return (
    <div className="product-config" data-testid="ShoppingBag__product-config">
      <div className="product-color text-small">
        {labels.colourText}:{" "}
        <span className="font-weight-bold text-uppercase">{color ?? "-"}</span>
      </div>
      {showSize ? (
        <div
          data-testid="ShoppingBag__product-size"
          className="product-size text-small d-flex"
        >
          {labels.sizeText}:{" "}
          <span className="font-weight-bold text-uppercase">{size ?? "-"}</span>
        </div>
      ) : null}
    </div>
  );
};

export default ProductConfig;
